export default __webpack_public_path__ + "static/media/DeleteIconActive.b0a5e6ed.svg";